import { atom } from 'recoil'
import { SkillTypes } from 'services'

export const skillsList = atom<SkillTypes[]>({
  key: 'skillsList',
  default: []
})
